import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {MapUtils} from '../../shared/utils/mapper';
import {FXResponse} from 'src/app/models/response.model';
import {Socket} from 'ngx-socket-io';
import {WalletSetting} from 'src/app/models/wallet.model';
import {APP_CONFIG} from 'src/app/shared/common/config';
import {DUMMY_DATA} from 'src/app/shared/utils/data';
import {BannedClassificationUser, BannedUser} from 'src/app/models/platform-settings';

@Injectable()
export class PlatformSettingsService {
  // URL to web api.

  constructor(private http: HttpClient, private socket: Socket) {}

  getWalletSetting(): Observable<FXResponse<WalletSetting>> {
    return this.http
      .get(`${APP_CONFIG.BASE_API_LINK.PLATFORM_SETTING}/wallet`)
      .pipe(
        map((res: any) => {
          const data = res.data;
          const response = new FXResponse<WalletSetting>().deserialize(res);
          response.data = MapUtils.deserialize(WalletSetting, data);
          return response;
        })
      );
   /* return new Observable<FXResponse<WalletSetting[]>>((observer) => {
      const res: any = DUMMY_DATA.PLATFORM_SETTINGS.WALLET;
      observer.next(res);
      observer.complete();
    }).pipe(
      map((res: any) => {
        const data = res.data;
        const response = new FXResponse<WalletSetting>().deserialize(res);
        response.data = MapUtils.deserialize(WalletSetting, data);
        return response;
      })
    );*/
  }

  updateWalletSetting(walletSetting: WalletSetting): Observable<any> {
    const jsonData = MapUtils.serialize(walletSetting);
    return this.http
      .put(`${APP_CONFIG.BASE_API_LINK.PLATFORM_SETTING}/wallet`, jsonData)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  getBlackList(): Observable<FXResponse<BannedUser[]>> {
    return new Observable<FXResponse<BannedUser[]>>((observer) => {
      const res: any = DUMMY_DATA.PLATFORM_SETTINGS.BLACK_LIST;
      observer.next(res);
      observer.complete();
    }).pipe(
      map((res: any) => {
        const data = res.data;
        const response = new FXResponse<BannedUser[]>().deserialize(res);
        response.data = data.map((d: any) => {
          return MapUtils.deserialize(BannedUser, d);
        });
        return response;
      })
    );
  }

  getBlackListClassification(): Observable<
    FXResponse<BannedClassificationUser[]>
  > {
    return new Observable<FXResponse<BannedClassificationUser[]>>(
      (observer) => {
        const res: any = DUMMY_DATA.PLATFORM_SETTINGS.BLACK_LIST_CLASSIFICATION;
        observer.next(res);
        observer.complete();
      }
    ).pipe(
      map((res: any) => {
        const data = res.data;
        const response = new FXResponse<
          BannedClassificationUser[]
        >().deserialize(res);
        response.data = data.map((d: any) => {
          return MapUtils.deserialize(BannedClassificationUser, d);
        });
        response.paging = res.paging;
        return response;
      })
    );
  }
}
